import { render, staticRenderFns } from "./address.vue?vue&type=template&id=08cf69c3&scoped=true&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"
import style0 from "./address.vue?vue&type=style&index=0&lang=css&"
import style1 from "./address.vue?vue&type=style&index=1&id=08cf69c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf69c3",
  null
  
)

export default component.exports